import angular from 'angular';
import uiRouter from 'angular-ui-router';
import confirmDialogComponent from './confirmDialog.component';

let confirmDialogModule = angular.module('confirmDialog', [
  uiRouter
])

.component('confirmDialog', confirmDialogComponent)

.name;

export default confirmDialogModule;



// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.js